"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormRadioButton", {
    enumerable: true,
    get: function() {
        return FormRadioButton;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormRadioButton = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { label, extraInfo, className, disabled = false, ...props } = param;
    const { hasError, id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors, spacers } = (0, _Theme.useTheme)();
    const inputId = (0, _react.useMemo)(()=>{
        var _props_id, _ref;
        return (_ref = (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id) !== null && _ref !== void 0 ? _ref : "".concat(props.name, "-").concat(props.defaultValue);
    }, [
        props.id,
        props.name,
        props.defaultValue,
        id
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("label", {
        htmlFor: inputId,
        className: _style.default.dynamic([
            [
                "22242dc141f4474f",
                [
                    colors.grayscale[20],
                    extraInfo != null ? "0 0.25rem" : "0.25rem",
                    colors.blue[60],
                    colors.blue[60],
                    extraInfo != null ? "flex-start" : "center",
                    colors.status.danger.primary,
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.grayscale[3],
                    colors.grayscale[20],
                    colors.muted0,
                    spacers.s2
                ]
            ]
        ]) + " " + ("label ".concat(disabled ? "label--disabled" : "", " ").concat(hasError ? "label--error" : "", " ").concat(className !== null && className !== void 0 ? className : "").trim() || "")
    }, /*#__PURE__*/ _react.default.createElement("input", {
        ...props,
        ref: ref,
        id: inputId,
        "aria-describedby": hintId,
        type: "radio",
        disabled: disabled,
        className: _style.default.dynamic([
            [
                "22242dc141f4474f",
                [
                    colors.grayscale[20],
                    extraInfo != null ? "0 0.25rem" : "0.25rem",
                    colors.blue[60],
                    colors.blue[60],
                    extraInfo != null ? "flex-start" : "center",
                    colors.status.danger.primary,
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.grayscale[3],
                    colors.grayscale[20],
                    colors.muted0,
                    spacers.s2
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "22242dc141f4474f",
                [
                    colors.grayscale[20],
                    extraInfo != null ? "0 0.25rem" : "0.25rem",
                    colors.blue[60],
                    colors.blue[60],
                    extraInfo != null ? "flex-start" : "center",
                    colors.status.danger.primary,
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.grayscale[3],
                    colors.grayscale[20],
                    colors.muted0,
                    spacers.s2
                ]
            ]
        ]) + " " + "info"
    }, label, extraInfo != null && /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "22242dc141f4474f",
                [
                    colors.grayscale[20],
                    extraInfo != null ? "0 0.25rem" : "0.25rem",
                    colors.blue[60],
                    colors.blue[60],
                    extraInfo != null ? "flex-start" : "center",
                    colors.status.danger.primary,
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.grayscale[3],
                    colors.grayscale[20],
                    colors.muted0,
                    spacers.s2
                ]
            ]
        ]) + " " + "extraInfo"
    }, extraInfo))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "22242dc141f4474f",
        dynamic: [
            colors.grayscale[20],
            extraInfo != null ? "0 0.25rem" : "0.25rem",
            colors.blue[60],
            colors.blue[60],
            extraInfo != null ? "flex-start" : "center",
            colors.status.danger.primary,
            colors.grayscale[10],
            colors.grayscale[60],
            colors.grayscale[3],
            colors.grayscale[20],
            colors.muted0,
            spacers.s2
        ]
    }, 'input[type="radio"].__jsx-style-dynamic-selector{width:16px;height:16px;background:#fff;border:1px solid '.concat(colors.grayscale[20], ";-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;position:relative;margin:").concat(extraInfo != null ? "0 0.25rem" : "0.25rem", ';cursor:pointer}input[type="radio"].__jsx-style-dynamic-selector:checked{border-color:').concat(colors.blue[60], '}input[type="radio"].__jsx-style-dynamic-selector:checked:before{content:"";position:absolute;-webkit-transform:translate(50%,50%);-moz-transform:translate(50%,50%);-ms-transform:translate(50%,50%);-o-transform:translate(50%,50%);transform:translate(50%,50%);top:0;left:0;width:50%;height:50%;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;background-color:').concat(colors.blue[60], "}.label.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:").concat(extraInfo != null ? "flex-start" : "center", ";-webkit-align-items:").concat(extraInfo != null ? "flex-start" : "center", ";-moz-box-align:").concat(extraInfo != null ? "flex-start" : "center", ";-ms-flex-align:").concat(extraInfo != null ? "flex-start" : "center", ";align-items:").concat(extraInfo != null ? "flex-start" : "center", ";white-space:nowrap;max-width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;gap:.5rem;cursor:pointer}.label--error.__jsx-style-dynamic-selector,.label-error.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{border-color:").concat(colors.status.danger.primary, "}.label--active.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{cursor:default}.label--disabled.__jsx-style-dynamic-selector,.label--disabled.__jsx-style-dynamic-selector:not(.label--active):hover{cursor:auto}.label--disabled.label--active.__jsx-style-dynamic-selector{background-color:").concat(colors.grayscale[10], ";border-color:").concat(colors.grayscale[60], "}.label--disabled.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{cursor:not-allowed;background-color:").concat(colors.grayscale[3], ";border-color:").concat(colors.grayscale[20], "}.info.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;min-width:0;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.extraInfo.__jsx-style-dynamic-selector{color:").concat(colors.muted0, ";font-size:12px;padding:").concat(spacers.s2, " 0 0;white-space:wrap}")));
});
FormRadioButton.displayName = "FormRadioButton";

//# sourceMappingURL=FormRadioButton.js.map